import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const bannerSelector = createFeatureSelector<IState>('banner');
export const getBannersSelector = createSelector(bannerSelector, (state: IState) => state); 
export const getBannerSelector = createSelector(bannerSelector, (state: IState) => state.selectedItem); 
export const getBannersSelectorchanel = createSelector(bannerSelector, (state: IState) => state.filteredDate); 
export const getBannersPagination = createSelector(bannerSelector, (state: IState) => ({
    currentPage:state.currentPage,
    total: state.total,
    maxPages: state.maxPages,
    perPage: state.perPage

})); 



